import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../loader/loader.service';
import { ApiService } from '../service/api.service';
import Validation from './conform-pass.validator';
import { APP_DATE_FORMATS } from '../service/date.adapter';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { State, process } from '@progress/kendo-data-query';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-setting',
    templateUrl: './setting.component.html',
    styleUrls: ['./setting.component.css'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: APP_DATE_FORMATS,
        },
    ],
    standalone: false
})
export class SettingComponent implements OnInit {
  //registerForm: any = FormGroup;
  submitted = false;
  username: any;
  profileForm: any = FormGroup;
  userForm: any = FormGroup;
  resetPassowrdForm: any = FormGroup;
  maintenanceForm: any = FormGroup;
  public pageableWithAll: any = {
    pageSizes: [5, 10, 20, 50, 100, 'All']
  };
  image: any;
  ImageUrl: any;
  startTime: any;
  today = new Date();
  passwordChangeForm: FormGroup = new FormGroup({
    email: new FormControl(''),
    password1: new FormControl(''),
    password: new FormControl(''),
    confirmPassword: new FormControl(''),
  });
  maintenanceId: any;

  constructor(
    private readonly dialog: MatDialog,
    private readonly formBuilder: FormBuilder,
    private readonly _http: ApiService,
    private readonly toaster: ToastrService,
    private readonly _sanitizer: DomSanitizer,
     private readonly cd: ChangeDetectorRef,
    private readonly loaderService: LoaderService,
  ) {}
isAdmin :boolean = false;
  ngOnInit() {
    this.username = JSON.parse(localStorage['loginData']);
    this.isAdmin = this.username.IsAdmin === true;
    this.createForm();
  }

  createForm() {
    this.passwordChangeForm = this.formBuilder.group(
      {
        email: [
          '',
          [
            Validators.required,
            Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
          ],
        ],

        password1: ['', [Validators.required, Validators.minLength(6)]], //old pass

        password: ['', [Validators.required, Validators.minLength(6)]], //new pass

        confirmPassword: ['', [Validators.required, Validators.minLength(6)]],
      },
      {
        validators: [Validation.match('password', 'confirmPassword')],
      }
    );

    this.profileForm = this.formBuilder.group({
      email: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ]),
      ],
      name: [
        '',
        Validators.compose([Validators.required, Validators.maxLength(30)]),
      ],
      image: [''],
    });

    this.userForm = this.formBuilder.group({
      Id: [0],
      email: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
           Validators.pattern(/^(?!\s*$).+/)
        ]),
      ],
      firstName: [
        '',
        Validators.compose([Validators.required, Validators.maxLength(30),  Validators.pattern(/^(?!\s*$).+/)]),
      ],
      lastName: [''],
      password: ['', [Validators.required, Validators.minLength(6),  Validators.pattern(/^(?!\s*$).+/)]], //new pass
      confirmPassword: ['', [Validators.required, Validators.minLength(6),  Validators.pattern(/^(?!\s*$).+/)]],
      isAdmin: [false],    
      isActive: [true],
    }, {
      validators: Validation.match('password', 'confirmPassword')
    });

    this.resetPassowrdForm = this.formBuilder.group({
      Id: [0],     
      NewPassword: ['', [Validators.required, Validators.minLength(6),  Validators.pattern(/^(?!\s*$).+/)]], //new pass
      confirmPassword: ['', [Validators.required, Validators.minLength(6),  Validators.pattern(/^(?!\s*$).+/)]]     
    }, {
      validators: Validation.match('NewPassword', 'confirmPassword')
    });
    this.setValue();
  }

  get f() {
    return this.passwordChangeForm.controls;
  }
  setValue() {
    this.passwordChangeForm.patchValue({
      email: this.username.UserName,
      password1: this.username.PasswordHash,
    });
    this.ImageUrl =
      this.username.ImageUrl == null
        ? null
        : this._sanitizer.bypassSecurityTrustResourceUrl(
            this.username.ImageUrl
          );
    this.profileForm.patchValue({
      email: this.username.UserName,
      name: `${this.username.FirstName} ${this.username.LastName}`,
    });
  }

  onChangePwd() {
    this.submitted = true;
    if (this.passwordChangeForm.invalid) {
      return;
    }
    this.loaderService.show();
    let obj = {
      UserName: this.passwordChangeForm.value.email,
      OldPassword: this.passwordChangeForm.value.password1,
      NewPassword: this.passwordChangeForm.value.password,
      ConfirmPassword: this.passwordChangeForm.value.confirmPassword,
    };
    this._http.changePass(obj).subscribe((res: any) => {
      if (res.Success) {
        this.toaster.success('Password changed Successfully');
        localStorage.setItem('loginData', JSON.stringify(res.Data));
      } else if (res.ResponseCode  == '419') {
        this.toaster.error(' Old Password Not Match'); 
      } else{
         this.toaster.error('Something went wrong');
      }
      this.loaderService.hide();
    });
  }

  changeListener($event: any) {
    this.readThis($event.target);
  }

  readThis(inputValue: any): void {
    const file: File = inputValue.files[0];
    const myReader: FileReader = new FileReader();
    myReader.onloadend = (e) => {
      this.image = myReader.result;
      
    };
    myReader.readAsDataURL(file);
  }

  onUploadProfile() {
    let obj = {
      Id: this.username.Id,
      FirstName: this.profileForm.controls.name.value,
      LastName: '',
      UserName: this.profileForm.controls.email.value,
      ImageUrl: this.image,
    };
    this._http.updateProfile(obj).subscribe((res: any) => {
      if (res.Success) {
        this.toaster.success('Profile upload Successfully');
        localStorage.setItem('loginData', JSON.stringify(res.Data));

        this.setValue();
        location.reload();
      } else {
        this.toaster.error('Something went wrong');
      }
    });
  }
  
public state: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
    group: [],
    sort: [],
  };

  public originalData :any= [];
  action:boolean = false;
  isSubmitted = false;
  searchText:string = "";
  public kendoData :GridDataResult = { data: [], total: 0 };
  selectedDeleteId: number | null = null;
  status: boolean = false;
  selectedUser: any = [];
  @ViewChild("addEditDialog") addEditDialog: TemplateRef<any>;
  @ViewChild("resetPasswordDialog") resetPasswordDialog: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog: TemplateRef<any>;
  @ViewChild("updateStatusDialog") updateStatusDialog: TemplateRef<any>;
  dataStateChange(state: State): void {
    this.state = state;
    this.getAllUsers();
    this.kendoData = process(this.originalData, state);
  }
  onDelete(id?: number | null): void {
    this.selectedDeleteId = id ?? null;
    this.dialog.open(this.deleteDialog, {
      autoFocus: false,
      panelClass: 'popup_custom_width_small'
    })
  }
  updateStatusUser(): void {
    this.dialog.closeAll();
    this._http.updateUserStatus(this.selectedUser.Id, this.status).subscribe((response: any) => {
      if (response["Success"] === true) {
        this.loaderService.hide();
        this.getAllUsers();
        this.toaster.success('Status updated successfully');
      } else {
        this.loaderService.hide();
        this.getAllUsers();
        this.toaster.error('Failed to update status. Please try again.');
      }
    })
  }
  onViewClicked(dataItem?: any): void {
    this.isSubmitted = false; 
    if(dataItem){
      this.action = false;
      this.userForm.controls['Id'].setValue(dataItem.Id ?? '');
      this.userForm.controls['email'].setValue(dataItem.email ?? '');
      this.userForm.controls['firstName'].setValue(dataItem.firstName ?? '');
      this.userForm.controls['lastName'].setValue(dataItem.lastName ?? '');
      this.userForm.controls['isAdmin'].setValue(dataItem.isAdmin ?? false);
      this.userForm.controls['isActive'].setValue(dataItem.isActive ?? true);
    }else{
      this.action = true;
      this.userForm.reset();
    }

    this.dialog.open(this.addEditDialog, {
      autoFocus: false,
    })
  }
  onRowDoubleClick(event: any): void {
    const cell = (event.target as HTMLElement).closest('kendo-grid-list tr');
    if (!cell) return;

    const index = Array.from(cell.parentElement!.children).indexOf(cell);
    const dataItem = this.kendoData.data[index];

    if (dataItem) {
      this.onViewClicked(dataItem);
    }
  }
  getAllUsers(){
    this.loaderService.show();
    this._http.getAllUsers()
          .subscribe((response:any) => {
            if (response["Success"] === true && response["Data"] != null) {
              this.originalData = response["Data"].map((item: any) => ({
                Id: item.Id,
                firstName: item.FirstName,
                lastName: item.LastName,
                fullname: `${item.FirstName} ${item.LastName}`,
                email: item.UserName,
                IsActive: item.IsActive,
                IsAdmin: item.IsAdmin === 'True',
                createdDate: item.CreatedOn
              }));
              this.loadGridData();
              this.loaderService.hide();
            } else {
              this.originalData = [];
              this.kendoData.data = [];
              this.loaderService.hide();
            }
          })
  }
    loadGridData(): void {
      this.clearList();
    this.originalData = [...this.originalData];
    this.kendoData = process(this.originalData, this.state);
    this.cd.detectChanges();
  }
  public onToggleStatus(dataItem: any): void {
    this.status = dataItem.IsActive;
    this.selectedUser = dataItem;
     this.dialog.open(this.updateStatusDialog, {
      autoFocus: false,
    })
  }
  filterData(event: string): void {
    this.searchText = event;

    const filtered = this.originalData.filter((item: any) =>
      Object.values(item).some(val =>
        val?.toString().toLowerCase().includes(this.searchText.toLowerCase())
      )
    );

    this.kendoData = process(filtered, this.state);
  }
  clearList(): void {
    this.searchText = '';
    this.kendoData = process(this.originalData, this.state);
  }
  changePassword(){
    this.isSubmitted = true;
    if (this.resetPassowrdForm.invalid) {
      this.resetPassowrdForm.markAllAsTouched(); 
      return;
    }
    this.loaderService.show();
     const formData = this.resetPassowrdForm.value;
    this._http.UpdatePassword(formData)
          .subscribe((response:any) => {
            if (response["Success"] === true && response["Data"] != null) {
              this.toaster.success('Password updated Successfully');
              this.getAllUsers();
              this.loaderService.hide();
              this.dialog.closeAll();
            }else {
              this.toaster.error('Something went wrong. Please try again later.');
              this.loaderService.hide();
            }
          })
  }
  onResetPasswordClicked(id?: number | null){
    this.isSubmitted = false;
    this.resetPassowrdForm.reset();
    this.resetPassowrdForm.controls['Id'].setValue(id ?? '');
    this.dialog.open(this.resetPasswordDialog, {
      autoFocus: false,
    })
  }
  submitUser(): void {
    this.isSubmitted = true;
    if (!this.action) {
      if (this.userForm.controls.email.errors || this.userForm.controls.firstName.errors ) {
        this.userForm.markAllAsTouched();
        return;
      }
    }
    if (this.userForm.invalid && this.action) {
      this.userForm.markAllAsTouched(); 
      return;
    }
    const formData = this.userForm.value;
    this.loaderService.show();
    this._http.saveUser(formData)
          .subscribe((response:any) => {
            if (response["Success"] === true && response["Data"] != null) {
              if (this.action)
                this.toaster.success('User updated Successfully');
              else
                this.toaster.success('User added Successfully');
              this.getAllUsers();
              this.loaderService.hide();
              this.dialog.closeAll();
            }else if(response["ResponseCode"] == 404) {
              this.toaster.error('Email is Already Exists.');
              this.loaderService.hide();
            }
               else {
              this.toaster.error('Something went wrong. Please try again later.');
              this.loaderService.hide();
            }
          })
  }
  deleteUser(): void{
    if (this.selectedDeleteId) {
       this.loaderService.show();
    this._http.deleteUser(this.selectedDeleteId)
          .subscribe((response:any) => {
            if (response["Success"] === true && response["Data"] != null) {
              this.toaster.success('User deleted Successfully');
              this.getAllUsers();
              this.loaderService.hide();
            } else{
              this.toaster.error('Something went wrong. Please try again later.');
              this.loaderService.hide();
            }
            this.dialog.closeAll();
          })
    }
  }
  Noupdate(){
      const index = this.originalData.findIndex((u : any) => u.Id === this.selectedUser.Id); // or unique key
      if (index !== -1) {
        this.originalData[index].IsActive = !this.status;
      }
    this.loadGridData();
  }
}
